import { Box, Paper } from '@mui/material';
import { Button } from '../../../../components/shared';
import { ReconciliationWarnings } from '../components';
import MonthlyReconciliationDataPanel from '../MonthlyReconciliationDataPanel';

const MonthlyReconciliationResults = ({
  appliedFilters,
  assetWithVarianceData,
  classes,
  finalizedData,
  isFinalizingReconciliation,
  isSummaryLoading,
  isWarningsExpanded,
  onAssetLinkClick,
  onFinalize,
  onToggleWarnings,
  postingDate,
  selectedProductName,
  sublocationWarnings,
  weeklyPostingsData,
}) => {
  if (!appliedFilters || isSummaryLoading || !assetWithVarianceData) return null;

  return (
    <>
      <MonthlyReconciliationDataPanel
        weeklyPostingsData={weeklyPostingsData}
        selectedProductName={selectedProductName}
        assetWithVarianceData={assetWithVarianceData}
      />

      <Box mb={3} mt={2}>
        <ReconciliationWarnings
          warnings={sublocationWarnings}
          isExpanded={isWarningsExpanded}
          onToggle={onToggleWarnings}
          onAssetLinkClick={onAssetLinkClick}
        />
      </Box>

      {!finalizedData ? (
        <Paper elevation={0} className={classes.finalizeActionCard}>
          <Box className={classes.finalizeActionContent}>
            <Button
              variant="contained"
              color="primary"
              onClick={onFinalize}
              className={classes.finalizeButton}
              disabled={isFinalizingReconciliation || !postingDate}
            >
              {isFinalizingReconciliation ? 'Finalizing...' : 'Finalize'}
            </Button>
          </Box>
        </Paper>
      ) : null}
    </>
  );
};

export default MonthlyReconciliationResults;
